export enum ENUM__ml_asset_url_source {
  HUGGING_FACE_DIRECTORY = 'HUGGING_FACE_DIRECTORY',
  FILE = 'FILE',
  MULTIPLE_FILES = 'MULTIPLE_FILES', //sorted and joined by delimeter "|"
  //
  LOCAL_FILE = 'LOCAL_FILE',
}
